import { categoryLessonSectionListAdapter } from '@/Module/HomePage/Store/Adapter';
import type { IState } from '@/Module/Store/Model';

export const {
  selectById: categoryLessonSectionListId,
  selectIds: categoryLessonSectionListIds,
  selectAll: categoryLessonSectionListAll,
} = categoryLessonSectionListAdapter.getSelectors<IState>(state => state.categoryLessonSectionList);
